import React from 'react';
import SelectionMenu from '../../components/selectionMenu';
import {useNavigate} from "react-router-dom";
import getMenuItems from "./adminPanelMenuItems";

const AdminPanel = () => {
    const navigate = useNavigate();
    const menuItems = getMenuItems(navigate);

    return (
        <div style={{ margin: "auto", width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <SelectionMenu items={menuItems} />
        </div>
    );
};

export default AdminPanel;
